export const DrinkMenu = [
  { type: "Gin", url: "gin", img: "" },
  { type: "Vodka", url: "vodka", img: "" },
  { type: "Scotch", url: "scotch", img: "" },
  { type: "Rum", url: "rum", img: "" },
  { type: "Tequila", url: "tequila", img: "" },
  { type: "Champagne", url: "champagne", img: "" },
  { type: "Brandy", url: "brandy", img: "" },
  { type: "Non-Alcoholic", url: "non_alcoholic", img: "" },
  { type: "Random", url: "random", img: "" },
];
